import React from "react";
import OfficeUnitForm from "./OfficeUnitForm";

export default function EditOfficeUnit() {
  return <OfficeUnitForm type={"Edit"} />;
}
